import { FETCH_RELEASE_NOTES, FETCH_RELEASE_NOTES_SUCCESS, RESET_RELEASE_NOTES } from 'Actions/ReleaseNotesActions';
import merge from 'lodash/merge';

import { LOADING_BEHAVIOR } from 'Actions/InfiniteScrollActions';

const initialState = {
	entities: {},
	result: {
		notes: []
	},
	page: 0,
	isFetching: false,
	loaded: false,
	pages: []
};

export const releaseNotes = (prevState = initialState, action) => {

	switch(action.type){
		case FETCH_RELEASE_NOTES:
			return {
				...prevState,
				isFetching: true,
				loaded: !( action.loadingBehavior === LOADING_BEHAVIOR.REFRESH )
			};

		case FETCH_RELEASE_NOTES_SUCCESS:
			if ( action.loadingBehavior === LOADING_BEHAVIOR.REFRESH) {
				return {
					...prevState,
					...action.data,
					isFetching: false,
					loaded: true,
					pages: [parseInt( action.data.page )]
				};

			} else {
				let pages, notes;
				if(action.loadingBehavior === LOADING_BEHAVIOR.PREPEND) {
					notes = [...action.data.result.notes, ...prevState.result.notes];
					pages = [action.data.page, ...prevState.pages];
				} else {
					notes = [...prevState.result.notes, ...action.data.result.notes];
					pages = [...prevState.pages, action.data.page];
				}
				return merge(
					{},
					prevState,
					action.data,
					{
						result: {
							notes: notes
						},
						isFetching: false,
						loaded: true,
						pages: pages
					}
				);
			}

		case RESET_RELEASE_NOTES:
			return initialState;

		default:
			return prevState;
	}
};




// WEBPACK FOOTER //
// ./src/reducers/releaseNotes.js